/** 한글(자모·완성형) 및 호환 자모 */
export const HANGUL_REGEX = /[\u3131-\u318E\uAC00-\uD7A3]/g;

/** 로그인 아이디·비밀번호 입력 한도 (input·검증·안내 메시지 공통 기준) */
export const LOGIN_INPUT_LIMITS = Object.freeze({
  id: { min: 4, max: 12 },
  password: { min: 10, max: 20 },
});

export const LOGIN_ID_MIN = LOGIN_INPUT_LIMITS.id.min;
export const LOGIN_ID_MAX = LOGIN_INPUT_LIMITS.id.max;
export const LOGIN_PW_MIN = LOGIN_INPUT_LIMITS.password.min;
export const LOGIN_PW_MAX = LOGIN_INPUT_LIMITS.password.max;

/** @param {number} maxLength */
export function getLoginMaxLengthExceededMessage(maxLength) {
  return `${maxLength}자리를 초과 할 수 없습니다.`;
}

/** @param {string} value */
export function stripHangul(value) {
  return String(value ?? '').replace(HANGUL_REGEX, '');
}

/**
 * @param {string} normalized
 * @param {number} maxLength
 */
function applyLoginMaxLength(normalized, maxLength) {
  return {
    value: normalized.slice(0, maxLength),
    rejectedLength: normalized.length > maxLength,
  };
}

/** 로그인 아이디 — 한글 제거, 소문자, 최대 길이 제한 */
export function sanitizeLoginUserId(value) {
  return parseLoginUserIdInput(value).value;
}

/**
 * 로그인 아이디 입력값 정규화 + 거부 사유
 * @param {string} value
 * @returns {{ value: string, rejectedHangul: boolean, rejectedLength: boolean }}
 */
export function parseLoginUserIdInput(value) {
  const raw = String(value ?? '');
  const rejectedHangul = HANGUL_REGEX.test(raw);
  const normalized = stripHangul(raw).toLowerCase();
  const { value: trimmed, rejectedLength } = applyLoginMaxLength(normalized, LOGIN_ID_MAX);
  return {
    value: trimmed,
    rejectedHangul,
    rejectedLength,
  };
}

/** 로그인 비밀번호 — 한글 제거, 최대 길이 제한 */
export function sanitizeLoginPassword(value) {
  return parseLoginPasswordInput(value).value;
}

/**
 * 로그인 비밀번호 입력값 정규화 + 거부 사유
 * @param {string} value
 * @returns {{ value: string, rejectedLength: boolean }}
 */
export function parseLoginPasswordInput(value) {
  const raw = String(value ?? '');
  const normalized = stripHangul(raw);
  const { value: trimmed, rejectedLength } = applyLoginMaxLength(normalized, LOGIN_PW_MAX);
  return {
    value: trimmed,
    rejectedLength,
  };
}
